import React from "react"
import PropTypes from "prop-types"
// Styles
import {
   HiddenCheckBox,
   Icon,
   StyledCheckbox,
   Wrapper,
} from "./Checkbox.styles"

const Checkbox = ({ checked, onChange, defaultChecked, readOnly }) => {
   return (
      <Wrapper>
         <HiddenCheckBox
            type="checkbox"
            checked={checked}
            defaultChecked={defaultChecked}
            onChange={onChange}
            readOnly={readOnly}
         />
         <StyledCheckbox
            checked={checked !== undefined ? checked : defaultChecked}
            bgColor={
               (checked !== undefined ? checked : defaultChecked)
                  ? "secondary"
                  : "medGrey"
            }
         >
            <Icon viewBox="0 0 24 24">
               <polyline points="20 6 9 17 4 12" />
            </Icon>
         </StyledCheckbox>
      </Wrapper>
   )
}

Checkbox.propTypes = {
   checked: PropTypes.bool,
   onChange: PropTypes.func,
   defaultChecked: PropTypes.bool,
   readOnly: PropTypes.bool,
}

export default Checkbox
